import React from 'react'
import Toggle from 'wix-base-ui/lib/controls/toggle'
import IconButton from './iconButton.jsx'
import _ from 'lodashParts'

class ToggleBtn extends React.Component {
    handleClick() {
        this.props.onClick()
        this.props.execCommand(this.props.cmdName)
    }

    render() {
        return (
            <Toggle className="no-scale"
                    disabled={this.props.disabled}
                    value={this.props.value}
                    automationId={this.props.automationId}
                    onChange={_.noop}>
                <IconButton className={'toggle-button ' + this.props.className}
                            onClick={() => this.handleClick()}
                            disabled={this.props.disabled}
                            style={this.props.style}
                            symbol={this.props.label}>
                    {this.props.children}
                </IconButton>
            </Toggle>
        )
    }
}

ToggleBtn.defaultProps = {
    onClick: _.noop,
    execCommand: _.noop,
    className: ''
}

ToggleBtn.propTypes = {
    cmdName: React.PropTypes.string,
    value: React.PropTypes.bool.isRequired,
    disabled: React.PropTypes.bool,
    label: React.PropTypes.string,
    execCommand: React.PropTypes.func,
    onClick: React.PropTypes.func
}

module.exports = ToggleBtn



// WEBPACK FOOTER //
// ./src/components/toolbar/toggleBtn.jsx